export default __webpack_public_path__ + "static/media/sponsor.8c60a886.jpg";